<template>
  <div class="transport-order">
    <a-button
      class="btn-cancel"
      type="primary"
      :disabled="selectedOrders.length === 0"
      @click="cancelOrderMultiple"
    >
      批量取消
    </a-button>
    <!-- <a-button class="goodsSelectStyle" @click="orderExport">导出订单</a-button> -->
    <a-table
      :columns="TRANSPORTTABLE"
      :data-source="orderList"
      size="middle"
      :scroll="{ x: 'calc(700px + 50%)'}"
      :loading="isLoadingTable"
      :pagination="pagination"
      :row-selection="{
        onSelect: handleRowSelect,
        onSelectAll: handleRowSelectAll,
        getCheckboxProps: rowSelect,
        onChange,
        selectedRowKeys: selectedRowKeys
      }"
      @change="handleTableChange"
    >
      <!-- 订单号 -->
      <template slot="odrNo" slot-scope="text, rowData">
        <span v-if="rowData.odrChannel === liuheOrderChannel">
          {{ rowData.unifyOdrNo }}
        </span>
        <p v-else class="textLine">
          <a @click="checkDetail(rowData)">{{ rowData.unifyOdrNo }}</a>
        </p>
        <p v-if="rowData.crmNumber" class="fontstyle"><span class="wai">外</span>{{ rowData.crmNumber }}</p>
      </template>
      <!-- 订单状态 -->
      <template slot="statusText" slot-scope="text, rowData">
        <div v-if="rowData.negotiationType === NEGOTIABLE" class="lineDiv yijia">
          <p class="lineStyle yijiaStyle">
            议价单
          </p>
        </div>
        <div class="flex align-center">
          <status-tag :type="rowData.textType" :text="filterText(text)"></status-tag>
          <img v-if="isCargoWarning" class="icon-noice" src="@/assets/img/icon_noice_file.png" alt="">
          <show-more v-if="isCargoWarning" :order-no="rowData.unifyOdrNo" />
        </div>
        <a-tooltip placement="top">
          <template slot="title">
            <p>
              {{ rowData.projectName }}
            </p>
          </template>
          <p class="address-txt-min testStyle">
            {{ rowData.projectName }}
          </p>
        </a-tooltip>
      </template>
      <!-- 货物信息 -->
      <template slot="goosInfo" slot-scope="text, rowData">
        <p>{{ rowData.goodsInfoFistLine }}</p>
        <p>{{ rowData.goodsInfoSecondLine }}</p>
      </template>
      <!-- 起始地信息 -->
      <template slot="startAddress" slot-scope="text, rowData">
        <div v-if="rowData.startStations && rowData.startStations.length">
          <p class="address-txt">
            {{ rowData.startStations[0].stationName }}
            {{ rowData.startStations.length > 1 ? ' 等' : '' }}
          </p>
          <div v-if="rowData.startStations.length > 1">
            <p class="phoneStyle">
              共 <span class="addressNumber">{{rowData.startStations.length}}</span> 个发货地
            </p>
          </div>
          <p v-if="rowData.startStations.length === 1" class="phoneStyle">
            {{rowData.startStations[0].contactName || '--'}}
            {{rowData.startStations[0].contactPhone || '--'}}
          </p>
        </div>
      </template>
      <!-- 目的地信息 -->
      <template slot="endAddress" slot-scope="text, rowData">
        <div v-if="rowData.isLine" class="lineDiv">
          <p class="lineStyle">
            {{rowData.lineName}}
          </p>
        </div>
        <div v-if="rowData.endStations && rowData.endStations.length">
          <p class="address-txt">
            {{ rowData.endStations[0].stationName }}
            {{ rowData.endStations.length > 1 ? ' 等' : '' }}
          </p>
          <div v-if="rowData.endStations.length > 1">
            <p class="phoneStyle">
              共 <span class="addressNumber">{{rowData.endStations.length}}</span> 个收货地
            </p>
          </div>
          <p v-if="rowData.endStations.length === 1" class="phoneStyle">
            {{rowData.endStations[0].contactName}}
            {{rowData.endStations[0].contactPhone}}
          </p>
        </div>
      </template>
      <!-- 订单总金额 -->
      <template slot="orderAmount" slot-scope="text, rowData">
        <div v-if="rowData.status === UnifyOrderStatusKey.BIDDING">
          <span v-if="filterBidding(rowData)">--</span>
          <div>
            <p><span>我的出价：</span><span>{{ rowData.negotiationBid.customerBidCost || '--' }}</span></p>
            <p><span>司机出价：</span><span>{{ rowData.negotiationBid.driverBidCostTax || '--' }}</span></p>
          </div>
        </div>
        <span v-else-if="rowData.cost" class="moneyStyle">
          {{rowData.cost}}
        </span>
        <span v-else class="order-amount">暂未计算</span>
      </template>
      <!-- 派车信息 -->
      <template slot="dispatchInfo" slot-scope="text, rowData">
        <span v-if="rowData.dispatchInfo.carsNum === 0">--</span>
        <div v-else-if="rowData.dispatchInfo.carsNum === 1">
          <p>{{ rowData.dispatchInfo.firstLine }}</p>
          <p>{{ rowData.dispatchInfo.secondLine }}</p>
        </div>
        <span v-else>
          共<a> {{ rowData.dispatchInfo.carsNum }} </a>辆
        </span>
      </template>
        <!-- 下单信息 -->
      <template slot="createTime" slot-scope="text, rowData">
        <p>{{rowData.createUserName}}</p>
        <span>{{text}}</span>
      </template>
      <!-- 操作栏 -->
      <span slot="action" slot-scope="text, rowData">
        <template v-if="rowData.odrChannel !== liuheOrderChannel">
          <a
            v-if="showEditButton(rowData.status, rowData.odrChannel)"
            v-track-click="{ trackName: '纯运输-编辑' }"
            class="action-btn"
            type="link"
            @click="editOrder(rowData, false)">
            编辑
          </a>
          <a
            v-track-click="{ trackName: '纯运输-再来一单' }"
            class="action-btn"
            type="link"
            @click="editOrder(rowData, true)"
          >
            再来一单
          </a>
          <a
            v-if="showCancelButton(rowData.status)"
            v-track-click="{ trackName: '纯运输-取消' }"
            class="action-btn removeStyle"
            type="link"
            @click="cancelOrder(rowData)"
          >
            取消
          </a>
        </template>
      </span>
    </a-table>
  </div>
</template>

<script>
import moment from 'moment'
import textType from '@/components/tag/constants.js'
import StatusTag from '@/components/tag/StatusTag.vue'
import { EventBus } from '@/utils/event-bus'
import ShowMore from './ShowMore.vue'
import { TRANSPORTTABLE, UnifyOrderStatus, UnifyOrderStatusKey, biddingList , typeNum } from '../const'
import { getTransportList, getInterface, getContract, cancelOrderUnify, orderExportUnify } from './transportApi'
import { getExceptionDetail, getOrderAlarmList } from '../api'
import env from '../../../../../env/index'

const orderChannel = 19  // 小程序下单
const NEGOTIABLE = 'NEGOTIABLE'
const contractImport = 16  // 批量导入下单
const liuheOrderChannel = 6

export default {
  name: 'TransportOrder',
  components: {
    StatusTag,
    ShowMore,
  },
  data() {
    return {
      NEGOTIABLE,
      UnifyOrderStatusKey,
      selectedOrders: [],
      selectedRowKeys: [],
      TRANSPORTTABLE,
      orderList: [],
      isLoadingTable: false,
      liuheOrderChannel,
      pagination: {
        current: 1,
        total: 0,
        defaultPageSize: 10,
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize
        },
        showQuickJumper: true,
        showTotal: total => `共 ${total} 条`
      },
      isCargoWarning: false,
      cargoWarningList: [],
    }
  },
  computed: {
  },
  created() {
    const { type } = this.$route.query
    const isCargoWarning = type === typeNum.CARGO_WARNING.value
    this.isCargoWarning = isCargoWarning
    this.getOrderList()
  },
  methods: {
    filterText(data){
      return UnifyOrderStatus[data] || ''
    },
    filterBidding(rowData){
      return rowData.negotiationBid && rowData.negotiationBid.bidStatus === biddingList.DISABLED
    },
    rowSelect(){
      return ({
          props: {
            disabled: this.tabsValue === 'FINISH',
          },
        })
    },
    showEditButton(status, channel) {
      const statuslist = [UnifyOrderStatusKey.EXP_CAL_STATUS, UnifyOrderStatusKey.SUBMITTED, UnifyOrderStatusKey.DRAFT]
      if(status !== undefined && status !== null){
        return statuslist.includes(status.toString()) && channel !== orderChannel
      }
      return false
    },
    showCancelButton(status) {
      const statuslist = [UnifyOrderStatusKey.EXP_CAL_STATUS, UnifyOrderStatusKey.SUBMITTED, UnifyOrderStatusKey.DRAFT, UnifyOrderStatusKey.DEAL, UnifyOrderStatusKey.CARRIER_BIDDING]
      if(status !== undefined && status !== null){
        return statuslist.includes(status.toString())
      }
      return false
    },
    async getOrderList() {
      const {projectIds,creditCode,customers,customerCode}=this.$store.state.user
      const params = {
        pageSize: this.pagination.pageSize,
        page: this.pagination.current
      }
      this.isLoadingTable = true
      try {
        let list = []
        // 轨迹预警处理
        if (this.isCargoWarning) {
          const filter = {
            ruleIds: env.ruleIds,
            startTime: moment().subtract(29, "days").startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            endTime: moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
          }
          if(creditCode){
            filter.customerCodes=customers.map(item=>item.customerCode)
          }else{
            filter.customerCodes=[customerCode]
          }
          const { current, pageSize } = this.pagination
          const res = await getOrderAlarmList({
            filter,
            paging: true,
            from: (current - 1)*pageSize,
            size:  pageSize,
          })
          res.records.forEach(item => {
            list.push(item.uOrderCode)
          })
          this.cargoWarningList = res.records || []
          this.pagination = {
            ...this.pagination,
            total: res.total,
          }
        } else {
       const data={
         ...params,
          exceptionType: this.$route.query.type,
          scenes: ['TRANSPORT_ONLY'],
       }
       if(creditCode){
         data.customerCodes=customers.map(item=>item.customerCode)
         data.projectIds=projectIds
       }else{
         data.customerCode=customerCode
         data.projectIds=projectIds
       }
          const detail = await getExceptionDetail(data)
          this.pagination = {
            ...this.pagination,
            // current: detail.page,
            // pageSize: detail.pageSize,
            total: detail.totalRows,
          }
          list = detail.list
        }
        if(list.length) {
          const res = await getTransportList({
            unifyNos: list
          }, {
            pageSize: this.pagination.pageSize,
            page: 1
          })
          const orderList = res.records.map(item => {
            // 处理货物信息数据
            let goodsName = ''
            let goodsSum = 0
            let goodsUnit = ''
            let goodsTotalWeight = 0
            let goodsTotalVolume = 0
            const enLength = item.endStations.length
            item.unifyOrderGoods.forEach((goodsItem, index, goods) => {
              if(enLength === 1 && goods.length === 1){
                goodsName = item.endStations[0].orderGoodsType === 0 ? '1个货品' : goods[0].skuName
                goodsSum = goods[0].number
                goodsUnit = goods[0].ext?.goodsUnit || ''
                goodsTotalWeight = goods[0].weight
                goodsTotalVolume = goods[0].volume
              } else {
                goodsName = `${goods.length}个货品`
                goodsSum += goodsItem.number || null
                goodsUnit = '件'
              }
            })

            // 处理派车信息数据
            const cars = item.dispatchList || []
            const dispatchInfo = {
              firstLine: `${cars[0]?.driverName} ${cars[0]?.driverPhone}`,
              secondLine: cars[0]?.licensePlate,
              carsNum: cars.length
            }
            const weight = this.formatFloatNum(goodsTotalWeight)
            const volume = this.formatFloatNum(goodsTotalVolume)
            const sum = this.formatFloatNum(goodsSum)
            return {
              ...item,
              key: item.unifyOdrNo,
              statusText: item.status,
              goodsInfoFistLine: sum ? `${goodsName} 共${sum}${goodsUnit}` : goodsName,
              goodsInfoSecondLine: this.filterSecondLine(weight, volume),
              createTime: moment(item.createTime).format('YYYY-MM-DD HH:mm:ss'),
              orderAmount: item.transportPrice?.toFixed(2),
              dispatchInfo,
              textType: textType(item.status)
            }
          })
          this.orderList = orderList
        }
      } finally {
        this.isLoadingTable = false
      }
    },
    filterSecondLine(weight, volume){
      if(weight && volume){
        return `共${weight}kg/${volume}M³`
      }
      if(weight && !volume){
        return `共${weight}kg`
      }
      if(!weight && volume){
        return `共${volume}M³`
      }
      return ''
    },
    formatFloatNum(num) {
      // eslint-disable-next-line no-nested-ternary
      return (num === null || num === undefined) ? '' : Number.isInteger(num) ? num : num.toFixed(3)
    },
    onChange(selectedRowKeys){
      this.selectedRowKeys = selectedRowKeys
    },
    cancelOrderMultiple() {
      const liuheList = this.selectedOrders.filter(item => item.odrChannel === liuheOrderChannel)
      if (liuheList.length) {
        this.$message.warning('六合接口创建的订单暂不支持取消')
        return
      }
      const odrNos = this.selectedOrders.map(item => item.unifyOdrNo)
      this.$confirm({
        content: '该操作会整体取消整个订单下所有子订单？',
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        onOk: async () => {
          this.onCancleOrders(odrNos)
          this.selectedOrders = []
          this.selectedRowKeys = []
        },
      })
    },
    async onCancleOrders(odrNos) {
      const res = await cancelOrderUnify({
        cancelReason: '货主端取消',
        cancelType: 'CANCEL_ALL',
        unifyOdrNos: odrNos
      })
      this.isLoadingTable = true
      setTimeout(() => {
        if(res && res.length > 2){
          const list = JSON.parse(res)
          this.$message.error({
            content: (<div>
            <p>{list.length}个订单取消失败</p>
            {this.getErr(list)}
            </div>),
          });
        } else {
          this.$message.success('取消成功')
        }
        this.getOrderList()
        this.$emit('getTotal')
      }, 1000)
    },
    getErr(list) {
      return list.map(item => {
        return <p>{item}</p>
      })
    },
    orderExport() {
      if(this.orderList.length <= 0){
        this.$message.warning('暂无订单数据')
        return
      }
      orderExportUnify({
        scene: ['TRANSPORT_ONLY'],
      }).then(() => {
        EventBus.$emit('taskPopover')
      })
    },
    handleTableChange(pagination) {
      this.pagination = {
        ...this.pagination,
        current: pagination.current
      }
      this.selectedRowKeys = [];
      this.selectedOrders = [];
      this.getOrderList();
    },
    handleRowSelect(record, selected, selectedRows) {
      this.selectedOrders = selectedRows
    },
    handleRowSelectAll(selected, selectedRows) {
      this.selectedOrders = selectedRows
    },
    checkDetail(rowData) {
      this.$router.push({
        path: `/order/detail`,
        query: {
          odrNo: rowData.unifyOdrNo
        },
      })
    },
    async editOrder(rowData, oneMoreOrder) {
      if(rowData.productCode) {
        // 判断是否有编辑权限
        const res = await getInterface({})
        const standardType = res.map((e) => {
          return e.productCode
        })
        if(!standardType.includes(rowData.productCode)){
          if(oneMoreOrder){
            this.$message.warning('请在BMS检查合同和报价的是否过期')
          } else {
            this.$message.warning('未找到相应合同产品，无法编辑')
          }
          return
        }
        this.$router.push({
          path: oneMoreOrder ? '/order/createOrder' : `/order/editOrder`,
          query: {
            odrNo: rowData.unifyOdrNo,
             customerCode:rowData.tenantId,
            productCode: rowData.productCode,
            oneMoreOrder: oneMoreOrder || ''
          },
        })
      } else {
        if (rowData.odrChannel === contractImport) {
          this.$router.push({
            path: oneMoreOrder ? '/order/createOrder' : `/order/editOrder`,
            query: {
              odrNo: rowData.unifyOdrNo,
               customerCode:rowData.tenantId,
              contractCode: rowData.contractCode,
              contractTermCode: rowData.contractTermCode,
              offContract: true,
              productCode: 'transport',
              oneMoreOrder: oneMoreOrder || ''
            },
          })
          return
        }
        // 判断是否有相应的合同和条款
        const resList = await getContract({
          cargoOwnerCode: this.$store.state.user.customerCode,
          status: 'ENABLED',
          needAllContracts: true,
        })
        const arr = resList.map((e) => {
          return e.contractCode
        })
        // 判读是否有相应的合同
        if(!arr.includes(rowData.contractCode)){
          if(oneMoreOrder){
            this.$message.warning('合同不存在，请维护合同')
          } else {
            this.$message.warning('无合同编辑')
          }
          return
        }
        const tremList = resList.filter((e) => {
          return e.contractCode === rowData.contractCode
        })
        const trem = tremList[0].contractTermInfo.map((e) => {
          return e.code
        })
        // 一单一议不校验条款
        if(tremList[0].negotiationType !== 'NEGOTIABLE'){
          // 判断是否有相应的条款
          if(!trem.includes(rowData.contractTermCode)){
            if(oneMoreOrder){
              this.$message.warning('合同条款不存在，请维护合同条款')
            } else {
              this.$message.warning('无条款编辑')
            }
            return
          }
        }
        this.$router.push({
          path: oneMoreOrder ? '/order/createOrder' : `/order/editOrder`,
          query: {
            odrNo: rowData.unifyOdrNo,
             customerCode:rowData.tenantId,
            contractCode: rowData.contractCode,
            contractTermCode: rowData.contractTermCode,
            productCode: 'transport',
            oneMoreOrder: oneMoreOrder || ''
          },
        })
      }
    },
    cancelOrder(rowData) {
      const odrNos = [rowData.unifyOdrNo]
      this.$confirm({
        content: '该操作会整体取消整个订单下所有子订单？',
        okText: '确定',
        okType: 'primary',
        cancelText: '取消',
        onOk: async () => {
          const res = await cancelOrderUnify({
            cancelReason: '货主端取消',
            cancelType: 'CANCEL_ALL',
            unifyOdrNos: odrNos
          })
          setTimeout(() => {
            if(res && res.length > 2){
              const list = JSON.parse(res)
              this.$message.error({
                content: (<div>
                <p>{list.length}个订单取消失败</p>
                {this.getErr(list)}
                </div>),
              });
            } else {
              this.$message.success('取消成功')
            }
            this.getOrderList()
            this.$emit('getTotal')
          }, 1000)
        },
      })
    }
  }
}
</script>


<style lang="less" scoped>
.transport-order {
  border: 0;
  .table-content {
    padding: 12px 30px;
    margin-top: 5px;
    background-color: #fff;
    border-radius: 6px;
  }
  .btn-cancel {
    margin-bottom: 12px;
  }
  .address-txt-min {
    width: 150px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .action-btn {
    padding: 0 8px;
  }
  .removeStyle{
    color: #606266;
  }
  .order-amount {
    color: #999999;
  }
  /deep/ .ant-tabs-tab-active{
    font-weight: bold !important;
  }
  /deep/ .ant-table-column-title{
    font-weight: bold;
  }
  .wai{
    display: inline-block;
    width: 16px;
    height: 16px;
    color: #fff;
    background: #606266;
    font-size: 12px;
    text-align: center;
    line-height: 16px;
    margin-right: 4px;
    margin-top: 4px;
    border-radius: 50%;
    img{
      width: 100%;
      height: 100%;
    }
  }
  /deep/ .ant-calendar-picker{
    // width: 250px !important;
    max-width: 100%;
  }
  .fontstyle{
    font-size: 12px;
    color: #999999;
  }
  .textLine{
    text-decoration: underline;
  }
  /deep/ .ant-input:placeholder-shown {
      font-size: 12px;
  }
  .testStyle{
    font-size: 12px;
    color: #ccc;
  }
  .create-list-wrap {
    ::v-deep {
      .ant-modal-body {
        padding: 0;
      }
    }
  }
  .create-list-item {
    color: #666666;
    font-size: 14px;
    line-height: 44px;
    padding-left: 64px;
    .iconfont {
      margin-right: 10px;
      color: #999999;
    }
    &:hover {
      cursor: pointer;
      background: rgb(223, 247, 235);
      color: #06B880;
      .iconfont {
        color: #06B880;
      }
    }
  }
  .lineDiv{
    height: 10px;
  }
  .lineStyle{
    display: inline-block;
    color: #FB9432;
    padding: 0 9px;
    font-size: 12px;
    height: 20px;
    line-height: 20px;
    background-image: url("../../../../assets/img/lineName.png");
    background-size: 100% 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 100%;
    position: absolute;
    top: 0;
    right: 0;
  }
  .yijiaStyle {
    display: inline-block;
    color: #06B880;
    background-image: url("../../../../assets/img/label_yijia.png");
    width: 77px;
    height: 20px;
    text-align: right;
  }
  .icon-noice {
    width: 16px;
    height: 16px;
    margin-left: 4px;
    margin-right: 8px;
  }
  .addressNumber{
    display: inline-block;
    border: 1px solid #606266;
    padding: 0 4px;
    height: 17px;
    line-height: 14px;
    font-size: 12px;
    text-align: center;
    border-radius: 9px;
  }
  .goodsSelectStyle{
    float: right;
  }
  .phoneStyle{
    color: #606266;
  }
  .moneyStyle{
    color: #ED4934;
  }
  .orderName{
    margin-top: 16px;
  }
}
</style>
